const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  FAQ: '/faq',
  NOT_FOUND: '/not-found',
  CART: '/cart',
  CHECKOUT: '/checkout',
  LOGIN: '/login',
  PROFILE: '/profile',
  PASSWORD_RECOVERY: '/password-recovery',
  CLAIM_ACCOUNT: '/claim',
  SHOP: '/shop',
  REGISTER: '/register',
  DETAILS: '/details',
  WISH_LIST: '/wish-list',
  ADMIN: '/admin',
  LIST: '/lists',
  TOP: '/top',
};

export default ROUTES;
